import { SVGInterface } from "../../interface";

const DoughnutChart = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 11.9999C2 7.162 5.43552 3.12649 10 2.19995V4.25195C6.54955 5.14004 4 8.27224 4 11.9999C4 16.4182 7.58172 19.9999 12 19.9999C15.7277 19.9999 18.8599 17.4504 19.748 13.9999H21.8C20.8734 18.5644 16.8379 21.9999 12 21.9999C6.47715 21.9999 2 17.5228 2 11.9999ZM21.8 9.99992C21.0046 6.08165 17.9183 2.99532 14 2.19995V4.25195C16.8112 4.97551 19.0244 7.1887 19.748 9.99992H21.8Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default DoughnutChart;
